// extracted by mini-css-extract-plugin
export default {"cartGridHeader":"cartGridHeader__MmJjO","cartGridHeaderItemLabel":"cartGridHeaderItemLabel__YTljY"};